module.exports = __webpack_public_path__ + "static/img/manual.629d2c15.png";